import { inject } from 'vue'

/**
 * Add migration helpers for Vue 3.
 */
export default function useVue3Migration (options = {}) {
  const { listeners } = options

  /**
   * Whether the component is running in Vue 3.
   */
  const isVue2 = inject('isVue2', true)

  /**
   * The global listeners object. Used to avoid unrecognized $listeners on vue 3.
   */
  const componentListeners = (isVue2 ? listeners : {}) || {}

  return {
    isVue2,
    componentListeners
  }
}
